import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Today's timed "thinking" loader (Service History, Pipeline): a title, the
 * unit, and steps that tick through done / active / pending; the last step
 * waits. Announced politely.
 */
export default function StepLoader({ title, unit, steps, durations }) {
    const [step, setStep] = useState(0);
    useEffect(() => {
        if (step >= steps.length - 1) return undefined;
        const t = setTimeout(() => setStep((s) => s + 1), durations[step]);
        return () => clearTimeout(t);
    }, [step, steps.length, durations]);
    const unitLabel = [unit?.YEAR_MANUF, unit?.MAKE, unit?.MODEL].filter(Boolean).join(' ');
    return (
        <div className="u2-card u2-steps-card" role="status">
            <div className="u2-c-head">
                <span className="u2-steps-pulse" aria-hidden="true" />
                <h3>{title}</h3>
                {unitLabel && <span className="u2-sub">{unitLabel}</span>}
            </div>
            <ol className="u2-steps">
                {steps.map((s, i) => {
                    const state = i < step ? 'ok' : i === step ? 'on' : 'pending';
                    return (
                        <li key={s.label} className={`is-${state}`}>
                            <span className="u2-steps-ic" aria-hidden="true">{state === 'ok' ? '✓' : ''}</span>
                            <span>
                                {s.label}
                                {state !== 'pending' && <small>{s.detail}</small>}
                            </span>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
}

StepLoader.propTypes = {
    title: PropTypes.string.isRequired,
    unit: PropTypes.object,
    steps: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, detail: PropTypes.string })).isRequired,
    durations: PropTypes.arrayOf(PropTypes.number).isRequired,
};
